import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal, Pencil, Archive, ArchiveRestore } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { CityFee } from '@libs/schemas';
import { safeMoneyFromCents } from '@libs/services/money';

export const createCityFeesColumns = (
  onEdit: (cityFee: CityFee) => void,
  onArchive: (cityFee: CityFee) => void,
  onUnarchive: (cityFee: CityFee) => void,
): ColumnDef<CityFee>[] => [
  {
    accessorKey: 'city',
    header: 'City',
    cell: ({ row }) => <div className="font-medium">{row.original.city}</div>,
  },
  {
    accessorKey: 'state',
    header: 'State',
    cell: ({ row }) => <div className="text-gray-600">{row.original.state}</div>,
  },
  {
    accessorKey: 'feeInCents',
    header: 'Fee',
    cell: ({ row }) => {
      return (
        <div className="text-text-primary">
          {safeMoneyFromCents(row.original.feeInCents).toFormat()}
        </div>
      );
    },
  },
  {
    accessorKey: 'archived',
    header: 'Status',
    cell: ({ row }) => (
      <Badge
        variant={row.original.archived ? 'destructive' : 'outline'}
        className={
          row.original.archived ? 'bg-destructive text-white' : 'bg-success-muted text-success'
        }
      >
        {row.original.archived ? 'Archived' : 'Active'}
      </Badge>
    ),
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => {
      const cityFee = row.original;

      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                onEdit(cityFee);
              }}
            >
              <Pencil className="mr-2 h-4 w-4" />
              Edit
            </DropdownMenuItem>
            {cityFee.archived ? (
              <DropdownMenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  onUnarchive(cityFee);
                }}
              >
                <ArchiveRestore className="mr-2 h-4 w-4" />
                Unarchive
              </DropdownMenuItem>
            ) : (
              <DropdownMenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  onArchive(cityFee);
                }}
              >
                <Archive className="mr-2 h-4 w-4" />
                Archive
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];
